import { CardFooterAction as CardFooterBehavior } from '../../extensions/constants/BehaviorTypes';
import { useBehavior } from '../../extensions/hooks/useBehavior';
import { useCardContext } from '../../context/CardContext';
import CardFooterActions from './CardFooterActions';
import { jsx as _jsx } from "react/jsx-runtime";
const CardFooter = ({
  toObjectTypeId,
  fromObjectTypeId,
  fromObjectId,
  hasScope,
  isUngated
}) => {
  const {
    associationDefinition,
    total,
    usageTracker,
    objectTypeDefinition,
    currentSearchQuery
  } = useCardContext();
  const cardFooterFunction = useBehavior(CardFooterBehavior, toObjectTypeId, hasScope, isUngated);
  const {
    primaryActionConfig,
    secondaryActionConfig
  } = cardFooterFunction({
    associationDefinition,
    fromObjectId,
    fromObjectTypeId,
    hasScope,
    objectTypeDefinition,
    toObjectTypeId,
    total,
    usageTracker,
    currentSearchQuery
  });
  return /*#__PURE__*/_jsx(CardFooterActions, {
    primaryActionConfig: primaryActionConfig !== null && primaryActionConfig !== void 0 ? primaryActionConfig : undefined,
    secondaryActionConfig: secondaryActionConfig !== null && secondaryActionConfig !== void 0 ? secondaryActionConfig : undefined,
    toObjectTypeId: toObjectTypeId,
    usageTracker: usageTracker
  });
};
export default CardFooter;